import HttpService from "./htttp.service";

class OAuthService {

  //   /**
  //  * Initiates OAuth login for a given provider by making an API request to the backend.
  //  * The backend will then handle the redirection.
  //  * @param {string} provider - The OAuth provider (e.g., "google", "facebook").
  //  */
  // initiateOAuthLogin = async (provider, postLoginRedirectUri) => {
  //   try {
  //     const oauthEndpoint = `/oauth/${provider}`;
  //     const payload = { provider, postLoginRedirectUri }; // send both

  //     const response = await HttpService.post(oauthEndpoint, payload);

  //     if (response.oauthUrl) {
  //       window.location.href = response.oauthUrl;
  //     } else {
  //       throw new Error("OAuth URL not received from backend");
  //     }
  //   } catch (error) {
  //     console.error(`Error initiating OAuth login for ${provider}:`, error.message);
  //   }
  // };

  /**
   * Initiates OAuth login for a given provider by making an API request to the backend.
   * Includes a CSRF-protection 'state' parameter.
   * @param {string} provider - The OAuth provider (e.g., "google", "facebook").
   */
  initiateOAuthLogin = async (provider, postLoginRedirectUri) => {
    try {
      // Step 1: Generate a unique state token for CSRF protection
      const state = crypto.randomUUID();

      // Step 2: Persist the state token locally for later validation
      localStorage.setItem('oauth_state', state);

      // Step 3: Send state + redirect URI to backend
      const oauthEndpoint = `/oauth/${provider}`;
      const payload = { provider, postLoginRedirectUri, state };

      const response = await HttpService.post(oauthEndpoint, payload);

      if (response.oauthUrl) {
        // Step 4: Redirect to the provider’s authorization page
        window.location.href = response.oauthUrl;
      } else {
        throw new Error("OAuth URL not received from backend");
      }
    } catch (error) {
      console.error(`Error initiating OAuth login for ${provider}:`, error.message);
    }
  };


  /**
   * Handles the OAuth callback by exchanging the authorization code for tokens.
   * @param {string} provider - The OAuth provider (e.g., "google", "facebook").
   * @param {string} authorizationCode - The authorization code received from the provider.
   */
  handleOAuthCallback = async (provider, authorizationCode) => {
    const callbackEndpoint = `oauth/${provider}/callback`; // Backend endpoint for processing OAuth callback
    return await HttpService.post(callbackEndpoint, { code: authorizationCode });
  };

  /**
   * Refreshes the access token for the given provider.
   * @param {string} provider - The OAuth provider (e.g., "google", "facebook").
   * @param {string} refreshToken - The refresh token.
   */
  refreshToken = async (provider, refreshToken) => {
    const refreshEndpoint = `oauth/${provider}/refresh`;
    return await HttpService.post(refreshEndpoint, { refresh_token: refreshToken });
  };



  /**
     * ⚡️ NEW METHOD: Securely validates the response status against the backend's one-time flag.
     * This call consumes (deletes) the status record on the server if it matches.
     * * @param {string} provider - The OAuth provider (e.g., "youtube").
     * @param {string} status - The status from the URL path (e.g., "success", "no-channel").
     */
  validateResponse = async (provider, status) => {
    // URL pattern: /oauth/:provider/validate-response
    const validateEndpoint = `oauth/${provider}/validate-response`;

    // We send the status in the POST body to comply with the backend route definition
    return await HttpService.post(validateEndpoint, { status: status });
  };

}

export default new OAuthService();
